@if(mediaService.media() === 'xs' || mediaService.media() === 'sm') {
<div class="d-header-wrapper-mobile ">
    <span>Ihre Auswahl: <b>{{local_start() | date:'dd.MM.yyyy'}} {{!isOne() ? ' - ' + (local_end() |
            date:'dd.MM.yyy') +
            (selecteddif() ? ' (' + selecteddif() + (selecteddif() === 1 ? ' Tag)' : ' Tage)'): '') + ', ' +
            local_dauertitle() :
            ''}}</b></span>
</div>
<div class="calcontainermobile customscroll">
    @for (cal of calendars | async; track $index) {
    <div [id]="cal.class" class="mt16">
        <div class="month_header-mobile">
            <span>{{cal.header | date: 'MMMM, yyyy'}}</span>
        </div>
        <ng-container *ngTemplateOutlet="mymonth; context:{month:cal}"></ng-container>
    </div>
    }
</div>
<div class="titlewrp">
    <span class="stattitle">Wie lange soll Ihre Reise sein?</span>
</div>
@if(!setcustomdauer()) {
<div class="customchipwrapper-mobile">
    @for (item of section1; track $index) {
    @if(item.minDuration === local_mindauer() && item.maxDuration === local_maxdauer()) {
    <button class="custopmchip_active">
        <img src="../../../../assets/tvg/checked.svg" alt="checked">
        <span>{{item.name}}</span>
    </button>
    } @else {
    <button class="custopmchip" [class.disabled]="item.minDuration > selecteddif() || item.maxDuration > selecteddif()"
        (click)="selectDauer(item)">
        <span>{{item.name}}</span>
    </button>
    }
    }
    <button class="custopmchip" (click)="openModal()">
        @if(custom_dauertitle()?.length > 0) {
        <span>{{custom_dauertitle()}}</span>
        } @else {
        <span>Anzahl der Tage</span>
        }
        <img class="ml5p" src="../../../../assets/tvg/edit.svg" alt="edit">
    </button>

</div>
<div class="ubwrapper">
    <button class="custombutton customunfilled w100" (click)="sendDatas()">Übernehmen</button>
</div>
}
}@else {
<ng-container *ngTemplateOutlet="deskmode"></ng-container>
}

<ng-template #deskmode>
    <div class="calwrapper">
        <div class="d-header-wrapper">
            <span>Ihre Auswahl: <b>{{local_start() | date:'dd.MM.yyyy'}} {{!isOne() ? ' - ' + (local_end() |
                    date:'dd.MM.yyy') +
                    (selecteddif() ? ' (' + selecteddif() + (selecteddif() === 1 ? ' Tag)' : ' Tage)'): '') + ', ' +
                    local_dauertitle() :
                    ''}}</b></span>
        </div>
        <div class="calcontainer">
            <div class="first-cal-wrapper">
                <div class="month_header">
                    <button (click)="previus()" class="dirbtn">
                        <img src="../../../assets/tvg/left.svg" alt="left">
                    </button>
                    <span class="header-txt">{{first_header() | date: 'MMMM, yyyy'}}</span>
                    <span class="emptybtn"></span>
                </div>
                <ng-container *ngTemplateOutlet="mymonth; context:{month:first_month()}"></ng-container>
            </div>
            <div class="sec-cal-wrapper">
                <div class="month_header">
                    <span class="emptybtn"></span>
                    <span class="header-txt">{{second_header() | date: 'MMMM, yyyy'}}</span>
                    <button (click)="next()" class="dirbtn">
                        <img src="../../../assets/tvg/right.svg" alt="right">
                    </button>
                </div>
                <ng-container *ngTemplateOutlet="mymonth; context:{month:second_month()}"></ng-container>
            </div>
        </div>
        <div class="titlewrp">
            <span class="stattitle">Wie lange soll Ihre Reise sein?</span>
        </div>
        @if(!setcustomdauer()) {
        <div class="customchipwrapper">
            @for (item of section1; track $index) {
            @if(item.minDuration === local_mindauer() && item.maxDuration === local_maxdauer()) {
            <button class="custopmchip_active">
                <img src="../../../../assets/tvg/checked.svg" alt="checked">
                <span>{{item.name}}</span>
            </button>
            } @else {
            <button class="custopmchip"
                [class.disabled]="item.minDuration > selecteddif() || item.maxDuration > selecteddif()"
                (click)="selectDauer(item)">
                <span>{{item.name}}</span>
            </button>
            }
            }
            <button class="custopmchip" (click)="setcustomdauer.set(true)">
                @if(custom_dauertitle()?.length > 0) {
                <span>{{custom_dauertitle()}}</span>
                } @else {
                <span>Anzahl der Tage</span>
                }
                <img class="ml5p" src="../../../../assets/tvg/edit.svg" alt="edit">
            </button>

        </div>
        <div class="ubwrapper">
            <button class="custombutton customunfilled w242" (click)="sendDatas()">Übernehmen</button>
        </div>
        } @else {

        <div class="vonbiswrapper">
            <span>Anzahl der Tage</span>
            <div class="ubwrapper1">
                <input type="number" placeholder="von" [(ngModel)]="custom_mindauer"
                    (ngModelChange)="checkminDauer(custom_mindauer)">
                <input type="number" placeholder="bis" [(ngModel)]="custom_maxdauer"
                    (ngModelChange)="checkmaxDauer(custom_maxdauer)">
                <button class="custombutton customblue_unfilled w242"
                    (click)="setcustomdauer.set(false)">Abbrechen</button>
                @if(dauererrormin() || dauererrormax()) {
                <span class="errordauer">Die gewählte Reisedauer ist länger als Ihr Hin- und Rückreise-Zeitraum. Bitte
                    wählen Sie eine
                    andere Reisedauer oder ändern Sie Früheste Hinreise oder Späteste Rückreise</span>
                } @else {
                <button class="custombutton customunfilled w242"
                    (click)="setCustomDauer(custom_mindauer, custom_maxdauer)">Übernehmen</button>
                }
            </div>
        </div>
        }
    </div>
</ng-template>

<ng-template #mymonth let-month="month">
    <div class="caltab">
        <div class="month-wrapper">
            @for (hd of header_week; track $index) {
            <span class="mday">{{hd}}</span>
            }
        </div>
        <div class="day-wrapper">
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_0}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_1}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_2}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_3}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_4}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_5}"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #cells let-arr="arr">
    @for (md of arr; track $index) {
    <ng-container *ngTemplateOutlet="day; context:{md:md}"></ng-container>
    }
</ng-template>

<ng-template #day let-md="md">
    <button (click)="selectDay(md)" (mouseleave)="selectTmp_Day(null)" (mouseenter)="selectTmp_Day(md)" class="mday-btn"
        [class.start-date-btn]="md?.id?.length > 0 && ((local_start()?.length > 0 && md.id === local_start())) && !isOne()"
        [class.end-date-btn]="md?.id?.length > 0 && (local_end()?.length > 0 && md.id === local_end())"
        [class.included]="md?.id > local_start() && (md?.id < tmp_end()?.id || md?.id < local_end()) && !isOne()"
        [class.disabledday]="!md || md?.id < today()">
        <span
            [class.start-date]="md?.id?.length > 0 && ((local_start()?.length > 0 && md.id === local_start()) || (local_end()?.length > 0 && md.id === local_end()))">{{md?.value}}</span>
    </button>
</ng-template>



<span #origin="cdkOverlayOrigin" cdkOverlayOrigin style="display: none;"></span>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="showModal()"
    [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayPanelClass]="'sheetovrleypanel'"
    (backdropClick)="closeModal()">

    <div class="sheetbd" (click)="$event.stopPropagation()">
        <div class="shettheader" (click)="closeModal()">
            <img src="../../../../assets/tvg/close.svg" alt="close">
            <span>Anzahl der Tage</span>
        </div>
        <div class="mobileanderewrapper">
            <input type="number" placeholder="von" [(ngModel)]="custom_mindauer"
                (ngModelChange)="checkminDauer(custom_mindauer)">
            <input type="number" placeholder="bis" [(ngModel)]="custom_maxdauer"
                (ngModelChange)="checkmaxDauer(custom_maxdauer)">
            <button class="custombutton customblue_unfilled w100" (click)="closeModal()">Abbrechen</button>
            @if(dauererrormin() || dauererrormax()) {
            <span class="errordauer">Die gewählte Reisedauer ist länger als Ihr Hin- und Rückreise-Zeitraum. Bitte
                wählen Sie eine
                andere Reisedauer oder ändern Sie Früheste Hinreise oder Späteste Rückreise</span>
            } @else {
            <button class="custombutton customunfilled w100"
                (click)="setCustomDauer(custom_mindauer, custom_maxdauer);">Übernehmen</button>
            }
        </div>
    </div>

</ng-template>